// extracted by mini-css-extract-plugin
module.exports = {"container":"productLink_container__fk8YX","label":"productLink_label__zvCde"};